import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics, logEvent as firebaseLogEvent } from "firebase/analytics";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import {
  getFirestore,
  doc,
  setDoc,
  getDoc,
  updateDoc,
} from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyASFMproBAHVT60mcvrr8JRrjRwX3e4cS4",
  authDomain: "scripter-cdc73.firebaseapp.com",
  projectId: "scripter-cdc73",
  storageBucket: "scripter-cdc73.appspot.com",
  messagingSenderId: "657858472192",
  appId: "1:657858472192:web:6c385f6ea280998a3d2be5",
  measurementId: "G-JBG9F3MEQX",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const firestore = getFirestore(app);

// Initialize Auth
const auth = getAuth(app);

// Initialize Analytics
const analytics = getAnalytics(app);

const functionsInstance = getFunctions(app);
if (window.location.hostname === "localhost") {
  connectFunctionsEmulator(functionsInstance, "localhost", 5001);
}

// Adjusted logEvent function to use the initialized analytics object
const logEvent = (eventName, eventParams) => {
  firebaseLogEvent(analytics, eventName, eventParams);
};

export {
  app,
  auth,
  logEvent,
  firestore,
  getFirestore,
  doc,
  setDoc,
  getDoc,
  updateDoc,
};
